module.exports = __webpack_public_path__ + "img/germany-stomach-cancer-female.f823e14a.png";